module.exports = __webpack_public_path__ + "static/media/lucky-draw-bg.308c9902.png";